module.exports = __webpack_public_path__ + "static/media/logo.f003b49d.png";